module.exports = __webpack_public_path__ + "static/img/6729_phase_function_Paper_PointsHejduk_Prediction.91f77fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6729_phase_function_Paper_PointsHejduk_Prediction.png
// module id = GulV
// module chunks = 0